import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 42 48"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g fill=\"#71F2DB\" fill-rule=\"evenodd\" clip-path=\"url(#i-1862429689__a)\" clip-rule=\"evenodd\"><path d=\"m35.08 24.55-4.763 2.75H30.3V10.944l-14.168-8.18.006-.01L20.905 0l14.172 8.182v.002h.003zM4.769 38.684.002 35.93V19.566h.002l-.002-.003 14.174-8.183 4.763 2.75.009.013-14.166 8.18v16.36zm36.943-2.548V30.63l-.006-.01-14.168 8.18-14.166-8.18-.008.015v5.5l14.174 8.183.002-.003v.002z\"></path><path d=\"M28.349 12.07v5.5l-.008.014-14.166-8.18L.006 17.586 0 17.575V12.07l14.172-8.182v.001l.003-.003zM6.733 23.45l4.763-2.75h.016v16.357l14.169 8.18-.006.01L20.908 48 6.736 39.818v-.002h-.003zm16.042 10.346 4.763 2.75 14.174-8.183-.001-.003h.001V11.995l-4.767-2.752h-.012v16.36l-14.166 8.18z\"></path></g><defs><clipPath id=\"i-1862429689__a\"><path fill=\"#fff\" d=\"M0 0h42v48H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "helium-deploy"}) } }